// TODO: 4.0 - codemod should help to change `filterOption` to support node props.
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import omit from 'rc-util/lib/omit';
import classNames from 'classnames';
import RcSelect, { Option, OptGroup } from 'bonree-select';
import { OptionProps } from 'bonree-select/lib/Option';
import isArray from 'lodash/isArray';
import { ConfigContext } from '../config-provider';
import getIcons from './utils/iconUtil';
import SizeContext from '../config-provider/SizeContext';
import { getTransitionName } from '../_util/motion';
import Spin from '../spin';
import Checkbox from '../checkbox';
import notification from '../notification';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
import Tooltip from '../tooltip';
export { OptionProps };
const SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
const InternalSelect = (_a, ref) => {
    var { prefixCls: customizePrefixCls, bordered = true, className, getPopupContainer, dropdownClassName, listHeight = 332, listItemHeight = 32, size: customizeSize, notFoundContent, maxTagPlaceholder, defaultActiveFirstOption = false, maxSelected = 1000, allText, isSelectAll } = _a, props = __rest(_a, ["prefixCls", "bordered", "className", "getPopupContainer", "dropdownClassName", "listHeight", "listItemHeight", "size", "notFoundContent", "maxTagPlaceholder", "defaultActiveFirstOption", "maxSelected", "allText", "isSelectAll"]);
    const [globalLocale] = useLocaleReceiver('global');
    const [emptyLocale] = useLocaleReceiver('Empty');
    const [selectLocale] = useLocaleReceiver('Select');
    const { getPopupContainer: getContextPopupContainer, getPrefixCls, renderEmpty, direction, virtual, dropdownMatchSelectWidth, } = React.useContext(ConfigContext);
    const size = React.useContext(SizeContext);
    const prefixCls = getPrefixCls('select', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const mode = React.useMemo(() => {
        const { mode: m } = props;
        if (m === 'combobox') {
            return undefined;
        }
        if (m === SECRET_COMBOBOX_MODE_DO_NOT_USE) {
            return 'combobox';
        }
        return m;
    }, [props.mode]);
    const isMultiple = mode === 'multiple' || mode === 'tags';
    // ===================== Empty =====================
    let mergedNotFound;
    if (notFoundContent !== undefined) {
        mergedNotFound = notFoundContent;
    }
    else if (mode === 'combobox') {
        mergedNotFound = null;
    }
    else if (props.loading) {
        mergedNotFound = (<div style={{ textAlign: 'center', padding: '8px 0 6px' }}>
        <Spin />
      </div>);
    }
    else {
        mergedNotFound = renderEmpty('Select', props.showSearch || isMultiple ? emptyLocale === null || emptyLocale === void 0 ? void 0 : emptyLocale.description : undefined);
    }
    // ===================== Icons =====================
    const { suffixIcon, itemIcon, removeIcon, clearIcon } = getIcons(Object.assign(Object.assign({}, props), { multiple: isMultiple, prefixCls }));
    // ==================== onChange =====================
    // 限制选择内容最大数量
    const isMax = (values) => typeof maxSelected === 'number' && isArray(values) && values.length > maxSelected;
    const handleChange = (value, option, hasSelectedAll) => {
        var _a;
        if (!isMax(value)) {
            (_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, value, option, hasSelectedAll);
        }
        else {
            notification.warning({
                message: `${selectLocale === null || selectLocale === void 0 ? void 0 : selectLocale.maxSelected1} ${maxSelected} ${selectLocale === null || selectLocale === void 0 ? void 0 : selectLocale.maxSelected2}`,
            });
        }
    };
    const selectProps = omit(props, [
        'suffixIcon',
        'itemIcon',
        'onChange',
    ]);
    const rcSelectRtlDropDownClassName = classNames(dropdownClassName, {
        [`${prefixCls}-dropdown-${direction}`]: direction === 'rtl',
        [`${prefixCls}-dropdown-single`]: !isMultiple,
        [`${prefixCls}-dropdown-multiple`]: isMultiple,
    });
    const mergedSize = customizeSize || size;
    const mergedClassName = classNames({
        [`${prefixCls}-lg`]: mergedSize === 'large',
        [`${prefixCls}-sm`]: mergedSize === 'small',
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-borderless`]: !bordered,
    }, className);
    return (<RcSelect ref={ref} virtual={virtual} dropdownMatchSelectWidth={dropdownMatchSelectWidth} {...selectProps} onChange={handleChange} transitionName={getTransitionName(rootPrefixCls, 'slide-up', props.maxTagCount === 'responsive' ? '' : props.transitionName)} listHeight={listHeight} listItemHeight={listItemHeight} mode={mode} prefixCls={prefixCls} direction={direction} inputIcon={suffixIcon} menuItemSelectedIcon={itemIcon} removeIcon={removeIcon} clearIcon={clearIcon} notFoundContent={mergedNotFound} className={mergedClassName} getPopupContainer={getPopupContainer || getContextPopupContainer} dropdownClassName={rcSelectRtlDropDownClassName} defaultActiveFirstOption={defaultActiveFirstOption} maxTagPlaceholder={maxTagPlaceholder !== undefined
            ? maxTagPlaceholder
            : omittedValues => `+${omittedValues.length}`} selectAllText={allText || (globalLocale === null || globalLocale === void 0 ? void 0 : globalLocale.all)} 
    // allText为空，反显“全部”标签，不为空，则通过isSelectAll控制，
    // isSelectAll为true时，反显allText标签，为false时，反显所有选项
    isSelectAll={typeof isSelectAll === 'boolean' ? isSelectAll : !allText} 
    // eslint-disable-next-line react/no-unstable-nested-components
    selectAllIcon={({ checked, indeterminate, disabled, children }) => (<Checkbox checked={checked} indeterminate={indeterminate} disabled={disabled}>
          {children}
        </Checkbox>)} tooltip={Tooltip}/>);
};
const SelectRef = React.forwardRef(InternalSelect);
const Select = SelectRef;
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = SECRET_COMBOBOX_MODE_DO_NOT_USE;
Select.Option = Option;
Select.OptGroup = OptGroup;
export default Select;
